import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12 m-10" }
const _hoisted_11 = { class: "border border-primary mb-10" }
const _hoisted_12 = { class: "row gx-0 d-flex align-items-center justify-content-between fw-bold py-2 bg-primary" }
const _hoisted_13 = { class: "col-md-5" }
const _hoisted_14 = { class: "d-flex float-end" }
const _hoisted_15 = { class: "p-3" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "form-group mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = { class: "form-group mb-2" }
const _hoisted_21 = ["onUpdate:modelValue", "placeholder", "onInput"]
const _hoisted_22 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = { class: "form-group mb-2" }
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_26 = { class: "col-md-2" }
const _hoisted_27 = { class: "form-group mb-2" }
const _hoisted_28 = ["onUpdate:modelValue"]
const _hoisted_29 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_30 = { class: "col-md-1 mb-1" }
const _hoisted_31 = ["onClick", "disabled"]
const _hoisted_32 = { class: "col-md-12 mt-3" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.addDetachement,
        "validation-schema": _ctx.detachementSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateDetachement",
                  type: "date",
                  value: _ctx.getCurrentDate(),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateDetachement",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Magasin "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "magasin" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.magasinOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.selectedMagasin,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMagasin) = $event))
                    }, field, {
                      placeholder: "Sélectionner le magasin",
                      onSelect: _ctx.selectMag
                    }), null, 16, ["options", "modelValue", "onSelect"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "magasin",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Motif "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "motif",
                  as: "textarea",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrez le motif du détachement"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "motif",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-7" }, [
                    _createElementVNode("h5", { class: "fs-6 mx-1 text-black" }, "Ajouter les produits")
                  ], -1)),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-success",
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addRowProduit && _ctx.addRowProduit(...args)))
                      }, _cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "fa fa-plus-circle position-relative me-1 fs-12" }, null, -1),
                        _createTextVNode("Ajouter un produit ")
                      ]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row mt-10" }, [
                    _createElementVNode("div", { class: "col-md-4" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold" }, [
                        _createTextVNode(" Produit Source "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Quantité Source "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-3" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Produit Cible "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-2" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                        _createTextVNode(" Quantité Cible "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-md-1" }, [
                      _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Action ")
                    ]),
                    _createElementVNode("hr", { class: "mt-0" })
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, produitIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row gy-0",
                      key: produitIndex
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_Multiselect, {
                            options: _ctx.produitOptions,
                            searchable: true,
                            "track-by": "value",
                            label: "label",
                            modelValue: produit.produitSource,
                            "onUpdate:modelValue": ($event: any) => ((produit.produitSource) = $event),
                            placeholder: "Sélectionner le produit source",
                            onSelect: (option) => _ctx.selectProd(produit, true, produitIndex, option),
                            onClear: ($event: any) => (_ctx.onClearProduitSource(produit, produitIndex))
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect", "onClear"]),
                          (_ctx.validateRowProduit(produit.produitSource, produitIndex, 'produitSource'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Le produit source est obligatoire. "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((produit.qtiteSource) = $event),
                            class: _normalizeClass(_ctx.validateRowProduit(produit.qtiteSource, produitIndex, 'qtiteSource') ? 
                          'form-control shadow-none fs-md-15 text-black is-invalid' : 
                          'form-control shadow-none fs-md-15 text-black'),
                            placeholder: produit.stockDisponible ? `Disponible : ${produit.stockDisponible}` : 'Entrer la quantité',
                            min: "1",
                            onInput: ($event: any) => (_ctx.calculateQuantiteCible(produit, produitIndex))
                          }, null, 42, _hoisted_21), [
                            [
                              _vModelText,
                              produit.qtiteSource,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          (_ctx.validateRowProduit(produit.qtiteSource, produitIndex, 'qtiteSource'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, " La quantité source doit être positive. "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_Multiselect, {
                            options: _ctx.getProduitCibleOptions(produit.produitSource),
                            searchable: true,
                            "track-by": "value",
                            label: "label",
                            modelValue: produit.produitCible,
                            "onUpdate:modelValue": ($event: any) => ((produit.produitCible) = $event),
                            placeholder: "Sélectionner le produit cible",
                            onSelect: (option) => _ctx.selectProd(produit, false, produitIndex, option),
                            onClear: ($event: any) => (_ctx.onClearProduitCible(produit, produitIndex))
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect", "onClear"]),
                          (_ctx.validateRowProduit(produit.produitCible, produitIndex, 'produitCible'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Le produit cible est obligatoire. "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((produit.qtiteCible) = $event),
                            class: _normalizeClass(_ctx.validateRowProduit(produit.qtiteCible, produitIndex, 'qtiteCible') ? 'form-control shadow-none fs-md-15 text-black is-invalid' : 'form-control shadow-none fs-md-15 text-black'),
                            placeholder: "Entrer la quantité",
                            min: "0",
                            disabled: ""
                          }, null, 10, _hoisted_28), [
                            [
                              _vModelText,
                              produit.qtiteCible,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          (_ctx.validateRowProduit(produit.qtiteCible, produitIndex, 'qtiteCible'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, " La quantité cible doit être un nombre entier positif. "))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("button", {
                          class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                          type: "button",
                          onClick: ($event: any) => (_ctx.removeRowProduit(produitIndex)),
                          disabled: _ctx.produits.length === 1
                        }, _cache[7] || (_cache[7] = [
                          _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                        ]), 8, _hoisted_31)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("button", {
                  class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                  type: "submit",
                  disabled: _ctx.isDisable
                }, " Faire un détachement ", 10, _hoisted_34),
                _createVNode(_component_router_link, {
                  to: "/detachements/liste-detachements",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createElementVNode("i", { class: "fa fa-times lh-1 me-1 position-relative top-2" }, null, -1),
                    _createTextVNode(" Annuler ")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}